import { IFileResponse, My_actions, VideoResource } from '@api/client';

export interface FileStreamActions {
  actions: VideoResource | null;
  myActions: My_actions | null;
}

export function mapFileActionsToStream(file: IFileResponse | null | undefined): FileStreamActions {
  const userActions = file?.user_actions;
  if (!userActions) {
    return { actions: null, myActions: null };
  }

  const actions = new VideoResource({
    likes: normalizeCount(userActions.likes),
    dislikes: normalizeCount(userActions.dislikes),
    watches: normalizeCount(userActions.watches),
    comments_count: normalizeCount(userActions.comments_count),
  });

  const myActions = new My_actions({
    my_reaction: typeof userActions.my_reaction === 'string' ? userActions.my_reaction : undefined,
    i_watched: typeof userActions.i_watched === 'boolean' ? userActions.i_watched : undefined,
  });

  return { actions, myActions };
}

function normalizeCount(value: unknown): number | undefined {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === 'string') {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }
  return undefined;
}
